export default "__VITE_PUBLIC_ASSET__c25c36b3__"